var Events = require('f.core.event');

var DataCenter = function (options) {
  this.datas = {};
  this.options = options;
  this.init();
};

DataCenter.prototype.init = function () {
  this.id = this.options.id;
  this.initData();
};

DataCenter.prototype.initData = function () {
  var url = this.options.getPlaybackUrl;
  var data = {
    format: 'jsonp'
  };
  $.ajax({
    url: url + this.id,
    type: 'get',
    dataType: 'jsonp',
    data: data,
    success: function (msg) {
      this.datas = msg;
    }.bind(this)
  });
};

DataCenter.prototype.getRange = function (begin, end) {
  var result = [];
  var t;
  for (var i = begin + 1; i <= end; i++) {
    t = 't' + i;
    if (this.datas[t]) {
      result = result.concat(this.datas[t]);
    }
  }
  if (result.length > 0) {
    this.trigger('dataMax', result);
  }
};

DataCenter.prototype.getData = function (offset) {
  var t = 't'+ offset;

  if (this.datas[t]) {
    this.trigger('data', this.datas[t]);
  }
};

var sendIndex = 0;

DataCenter.prototype.sendData = function (data, offset) {
  var id = this.options.id;
  var url = this.options.sendUrl;
  var datainfo = {
    article_id: id,
    title: document.title.replace('凤凰', ''),
    url: window.location.href,
    content: data.content,
    fontsize: data.size,
    offset: offset,
    color: data.color,
    app: 'flash',
    type: 'normal',
    format: 'jsonp'
  };
  $.ajax({
    url: url,
    type: 'get',
    dataType: 'jsonp',
    data: datainfo,
    success: function (msg) {
      data.id = 'sendBack_' + sendIndex++;
      this.trigger('send', [data]);
    }.bind(this)
  });
};

DataCenter.prototype.changeData = function (id) {
    this.id = id;
    this.initData();
};

Events.mixTo(DataCenter);
module.exports = DataCenter;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/dataCenter/playback.js